import { render, staticRenderFns } from "./mobile_home.vue?vue&type=template&id=1cf09a34&scoped=true&"
import script from "./mobile_home.vue?vue&type=script&lang=js&"
export * from "./mobile_home.vue?vue&type=script&lang=js&"
import style0 from "./mobile_home.vue?vue&type=style&index=0&id=1cf09a34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf09a34",
  null
  
)

export default component.exports